import React, {useRef, useState} from 'react';

import i18next from 'i18next';

import {useTranslation} from 'react-i18next';
import * as yup from 'yup';

import {FileFormPropsCallback, XlsxFileForm} from 'components/common/XlsxFileForm';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {downloadXlsx} from 'utils/downloadXlsx';

import {UploadContainer, UploadDescription, UploadFooter} from './styled';

interface XlsxFileModalProps {
    open: boolean;
    onClose: () => void;
    onFileChange: (data: FileFormPropsCallback) => void;
    initialFile?: File | null;
    submit?: (valid: boolean) => JSX.Element;
}

export const XlsxFileModal = ({
    open,
    onClose,
    onFileChange,
    initialFile,
    submit,
}: XlsxFileModalProps) => {
    const {t} = useTranslation();
    const modalRef = useRef<HTMLDivElement>(null);
    const [valid, setValid] = useState(false);

    const codesSchema = () =>
        yup
            .array()
            .of(
                yup
                    .object({
                        code: yup.string().required('components.form.required'),
                    })
                    .uniqueProperty('code', i18next.t('components.form.unique')),
            )
            .min(1, `${i18next.t('components.form.min')} 1`);

    const handleFileChanged = ({data, file, isValid}: FileFormPropsCallback) => {
        onFileChange({data, file, isValid});
        setValid(!!isValid);
    };

    return (
        <Modal show={open} onClose={onClose} title={t('components.upload.title')} modalWidth={0}>
            <UploadContainer ref={modalRef} tabIndex={-1}>
                <UploadDescription>{t('components.upload.description')}</UploadDescription>
                <XlsxFileForm
                    onChange={handleFileChanged}
                    scheme={codesSchema()}
                    assessors={{code: 'A'}}
                    initialValue={initialFile}
                    linkExample="/examples/codes.xlsx"
                    linkExampleAction={(path) => downloadXlsx({path, localePath: 'examples.code'})}
                />
                <UploadFooter>
                    <Button variant={ButtonVariant.Outline} onClick={onClose}>
                        {t('components.form.Cancel')}
                    </Button>
                    {submit?.(valid)}
                </UploadFooter>
            </UploadContainer>
        </Modal>
    );
};
